import { TooltipProvider } from '@/components/ui/tooltip';
import { useAuth } from '@/contexts/auth.context';
import { useActivityHeartbeat } from '@/hooks/heartbeat/useActivityHeartbeat';
import { Toaster } from 'react-hot-toast';

interface Props {
  children: React.ReactNode;
}

export default function Providers({ children }: Props) {
  const { initialized, token } = useAuth();

  useActivityHeartbeat({
    enabled: initialized && Boolean(token),
  });

  return (
    <>
      <Toaster />
      <TooltipProvider>{children}</TooltipProvider>
    </>
  );
}
